import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useCustomerTabs = () => {
  const { t } = useTranslation('customers');

  return useMemo(
    () => [
      {
        label: t('users'),
      },
      {
        label: t('projects'),
      },
      {
        label: t('aiFeatures'),
      },
      {
        label: t('restAPI'),
        disabled: true,
        tooltip: t('comingSoon'),
      },
      {
        label: t('purchases'),
        disabled: true,
        tooltip: t('comingSoon'),
      },
      {
        label: t('logs'),
        disabled: true,
        tooltip: t('comingSoon'),
      },
    ],
    [t],
  );
};

export default useCustomerTabs;
